import React, { useState, useEffect } from 'react';
import { Button, Box, Typography, TextField } from '@mui/material';
import axios from 'axios';

const Accomplishments = () => {
  const [data, setData] = useState([]);
  const [desc, setDesc] = useState('');
  const token = localStorage.getItem('token');

  const fetchAccomplishments = () => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/accomplishments`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setData(res.data))
      .catch((err) => console.error('Fetch error:', err));
  };

  useEffect(() => {
    fetchAccomplishments();
  }, []);

  const addAccomplishment = () => {
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/accomplishments`,
        { description: desc },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        setDesc('');
        fetchAccomplishments(); // refresh data
      })
      .catch((err) => console.error('Add error:', err));
  };

  const deleteAccomplishment = (id) => {
    axios
      .delete(`${process.env.REACT_APP_API_BASE_URL}/api/admin/accomplishments/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => fetchAccomplishments())
      .catch((err) => console.error('Delete error:', err));
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Accomplishments</Typography>
      <TextField
        value={desc}
        onChange={(e) => setDesc(e.target.value)}
        placeholder="Enter description"
        variant="outlined"
        size="small"
        sx={{ mr: 1 }}
      />
      <Button onClick={addAccomplishment} variant="contained">Add</Button>

      <ul>
        {data.map((row) => (
          <li key={row.id}>
            {row.description} - {row.created_by}
            <Button
              variant="text"
              color="error"
              onClick={() => deleteAccomplishment(row.id)}
              sx={{ ml: 1 }}
            >
              Delete
            </Button>
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default Accomplishments;
